export const initialState = {
  user: null,
  playlists: [],
  playing: false,
  item: null,
  // token:
  //   "BQCLzqOhrsu4mLvRkt2HPq8gb_-GNPWFVWh49rRmiv4r8gDpvRbMpiW9q455SLBWCxXc-9wndJiUq8Lw18hUZfgoLd3F9F2eRVClQatUWP4PK_rD7SRAG4QY_qrlGOYuZxKsUklIFn_CsEuhI501iM1P89mJWgWEqgzu8JsGz3uKaap2m8Ox",
};

const reducer = (state, action) => {
  console.log(action);

  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        user: action.user,
      };
    case "SET_TOKEN":
      return {
        ...state,
        token: action.token,
      };
    case "SET_PLAYLISTS":
      return {
        ...state,
        playlists: action.playlists,
      };
    case "SET_DISCOVER_WEEKLY":
      return {
        ...state,
        discover_Weekly: action.discover_Weekly,
      };
    default: {
      return state;
    }
  }
};

export default reducer;
